import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

const getToastTitle = (item) => {
  if (item?.title) {
    return item.title;
  }

  switch (item?.type) {
    case 'success':
      return 'İşlem tamamlandı';
    case 'error':
      return 'İşlem başarısız';
    case 'warning':
      return 'Dikkat';
    default:
      return 'Bilgi';
  }
};

const VenueToastStack = ({ feedbackItems, onDismiss }) => {
  if (!feedbackItems?.length) {
    return null;
  }

  return (
    <ToastContainer position="top-end" className="p-3 venue-toast-container">
      {feedbackItems.map((item) => (
        <Toast
          key={item.id}
          className={`venue-toast venue-toast--${item.type || 'info'}`}
          bg="light"
          delay={item.autoHideMs}
          autohide
          onClose={() => onDismiss(item.id)}
        >
          <Toast.Header closeButton>
            <strong className="me-auto">{getToastTitle(item)}</strong>
          </Toast.Header>
          <Toast.Body>{item.message}</Toast.Body>
        </Toast>
      ))}
    </ToastContainer>
  );
};

export default VenueToastStack;

